import PropTypes from 'prop-types'
import React from 'react'
import classnames from 'classnames'
import './Icon.less'

export default class Icon extends React.Component {
  render () {
    const classes = classnames(
      this.props.className,
      `nmc-icon-${this.props.name}`,
      `nmc-icon-${this.props.size}`
    )
    return (
      <span className={classes} />
    )
  }
}

Icon.propTypes = {
  name: PropTypes.string.isRequired,
  size: PropTypes.string
}

Icon.defaultProps = {
  size: 'medium',
  onClick: null,
  className: 'nmc-icon-default',
  clickable: true
}



// WEBPACK FOOTER //
// ../~/@master/webinfra-frontend-components/src/components/Icon/index.js